import React from 'react'
import { Link, ContentfulImage } from 'chemistry'

const ProductCardBanner = props => {
  const { link, image } = props
  if (!image?.image?.url) return null

  return (
    <div
      className='mxd-block-card mxd-block-card-banner mxd-block-card-responsive mxd-product-card-banner pl2'
      data-testid='product-card-banner'
    >
      <Link href={link} className='col-12' data-testid='product-card-link'>
        <ContentfulImage image={image} />
      </Link>
    </div>
  )
}

export default ProductCardBanner
